import { render, staticRenderFns } from "./DetailNote.vue?vue&type=template&id=01b1435d&scoped=true&"
import script from "./DetailNote.vue?vue&type=script&lang=js&"
export * from "./DetailNote.vue?vue&type=script&lang=js&"
import style0 from "./DetailNote.vue?vue&type=style&index=0&id=01b1435d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1435d",
  null
  
)

export default component.exports